import React from 'react';
import { Link } from 'react-router-dom';
import './Sections.css';

const Section4 = () => {
  const trustBadges = [
    { name: "MTD Ready" },
    { name: "HMRC Recognised" },
    { name: "100% Secure" },
    { name: "Cloud Based" }
  ];

  return (
    <section className="section-4">
      <div className="paycis-container">
        <h2 className="section-4-headline">
          The payments platform for savvy construction firms
        </h2>
        
        <div className="trust-bar">
          {trustBadges.map((badge, index) => (
            <div key={index} className="trust-badge">
              <span className="trust-name">{badge.name}</span>
            </div>
          ))}
        </div>
        
        <div className="section-4-cta">
          <Link to="/pricing" className="large-btn">
            SEE PRICES AND FEATURES →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Section4;